export function findNodePath(graphicsData, targets, keys = ['name']) {
  return findNodeAndPath(graphicsData, targets, keys).path;
}

export function findNode(graphicsData, targets, keys = ['name']) {
  return findNodeAndPath(graphicsData, targets, keys).node;
}

export function findNodeAndPath(graphicsData, targets, keys = ['name']) {
  if (!targets || !keys || !graphicsData?.children) return { node: null, path: null };
  function search(node, targets, keys, scope) {
    if (!(targets instanceof Array)) targets = [targets];
    if (!(keys instanceof Array)) keys = [keys];
    for (let index in node.children) {
      const currentNode = node.children[index];
      for (let target of targets) {
        for (let key of keys) {
          if (currentNode[key] === target) {
            return { node: currentNode, path: `${scope}.${index}` };
          } else if (currentNode.children) {
            const { node, path } = search(currentNode, target, key, `${scope}.${index}.children`);
            if (path) {
              return { node, path };
            }
          }
        }
      }
    }
    return { node: null, path: null };
  }
  return search(graphicsData, targets, keys, 'graphicsData.children');
}

export function findByFunction(graphicsData, func) {
  if (!func || !graphicsData?.children) return null;
  function search(node) {
    for (let index in node.children) {
      const currentNode = node.children[index];
      if (func(currentNode)) {
        return currentNode;
      } else if (currentNode.children) {
        const result = search(currentNode);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }
  return search(graphicsData);
}

export function findNodes(graphicsData, targets, keys = ['resourceId']) {
  const result = [];
  if (!targets || !keys || !graphicsData?.children) return [];
  if (!(targets instanceof Array)) targets = [targets];
  if (!(keys instanceof Array)) keys = [keys];
  function search(node) {
    if (!node.children) return;
    for (let index in node.children) {
      const currentNode = node.children[index];
      for (let target of targets) {
        for (let key of keys) {
          if (currentNode[key] === target && !result.includes(currentNode)) {
            result.push(currentNode);
          }
          if (node.children) {
            search(currentNode);
          }
        }
      }
    }
  }
  search(graphicsData);
  return result;
}

export function findNodePaths(graphicsData, targets, keys = ['resourceId']) {
  const result = [];
  if (!targets || !keys || !graphicsData?.children) return [];
  if (!(targets instanceof Array)) targets = [targets];
  if (!(keys instanceof Array)) keys = [keys];
  function search(node, path) {
    if (!node.children) return;
    for (let index in node.children) {
      const currentNode = node.children[index];
      for (let target of targets) {
        for (let key of keys) {
          if (currentNode[key] === target && !result.includes(currentNode)) {
            result.push(`${path}.${index}`);
          }
          if (node.children) {
            search(currentNode, `${path}.${index}.children`);
          }
        }
      }
    }
  }
  search(graphicsData, 'graphicsData.children');
  return result;
}

export function getHighestLayerIndex(graphicsData, types = ['sticker']) {
  const result = [];
  const layersOfType = findNodes(graphicsData, types, ['type']);
  let highest = 0;
  layersOfType.forEach((layer) => {
    const parts = layer.id.split('_');
    const layerCount = parseInt(parts[parts.length - 1]);
    if (layerCount > highest) highest = layerCount;
  });
  return highest;
}

export function findAllInScene(graphicsData, prop, value, deepSearch = false) {
  const scene = findCurrentScene(graphicsData);
  return deepSearch
    ? findNodes(scene?.node, value, prop)
    : scene?.node?.children?.filter((layer) => layer[prop] === value) || [];
}

export function findCurrentScene(graphicsData) {
  if (typeof window !== 'undefined') {
    graphicsData = graphicsData || window?.graphicsManager?.graphics?.data?.display;
    // Graphics is the only place that this data lives because of flipping
    const currentScene = window.graphicsManager?.graphics?.selection?.currentScene?.name;
    if (currentScene) {
      return findNodeAndPath(graphicsData, currentScene, 'name');
    }
  }
  return {
    node: graphicsData.children[0].children[0],
    path: 'graphicsData.children.0.children.0',
  };
}

export function findScenePath(graphicsData, path) {
  if (path && typeof path === 'string') {
    const parts = path.split('.');
    if (parts.length >= 5) return parts.splice(0, 5).join('.');
  }
  return findCurrentScene(graphicsData).path;
}

export function findParentPath(path) {
  const parts = path.split('.');
  parts.pop();
  parts.pop();
  return parts.join('.');
}
